let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kiYwA")).then(() => parcelRequire('4MZE8'));